import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { SignInDataType } from '../../../models/auth/signIn.model';
import { ErrorHttpResponse, HttpConfig } from '../../../models/https';
import useHttps from '../../useHttps';
import useSetAuthentication from '../useSetAuthentication';

const useSignin = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const { setAuthentication } = useSetAuthentication();


  const onSignInError = (err: AxiosError<ErrorHttpResponse>) => {
    toast.error(err?.response?.data?.message ?? 'Something went wrong');
  };

  const signin = (data: SignInDataType) => {
    const url: HttpConfig = {
      url: 'api/v1/auth/login',
      method: 'post',
      data,
    };

    request(url, setAuthentication, setLoading, onSignInError);
  };

  return {
    loading,
    signin,
  };
};

export default useSignin;
